<template>
  <select class="form-control"
    @change="changeAttributeStatus($event.target.value)">
    <option v-for="(status, key, index) in statuses" :key="index" :value="key" :selected="key==attr.status">{{status}}</option>
  </select>
</template>

<script>
export default {
  props: ['statuses', 'attr'],
  methods: {
    changeAttributeStatus (status) {
      this.$send.submit('post', 'api/project/' + this.attr.id + '/change/status', { status: status })
        .then(response => {
          this.attr.status = status
        })
    }
  }
}
</script>

<style>

</style>
